// Scaling rules.
// Decision 1 (Phase 1): a stored ingredient amount is for the recipe's BASE servings.
// "Cook for N" is display-only and never changes the recipe.
import { toNumber, type Amount } from './quantity.ts';

/** Ingredient amount when cooking for `cookFor` people. No rounding (display rounds). */
export function scaleIngredient(amount: Amount, baseServings: number, cookFor: number): number {
  return (toNumber(amount) * Math.max(cookFor, 1)) / Math.max(baseServings, 1);
}

/**
 * Utensil count — exact port of Swift RecipeUtensilRow.scaledAmount:
 * amount × ceil(servings / scaleEvery), or the fixed amount when scaleEvery is null.
 */
export function scaleUtensil(amount: number, scaleEvery: number | null, servings: number): number {
  if (scaleEvery == null) return Math.max(amount, 0);
  const scale = Math.max(scaleEvery, 1);
  const count = Math.max(servings, 1);
  return Math.max(amount, 0) * Math.ceil(count / scale);
}

/**
 * Grocery-list amount — exact port of Swift GroceryRecipe.scaledAmount, which works on the
 * raw fixed-point integer: max(1, ceil(raw × groceryServings / recipeServings)).
 * Returns a new Amount with the same decimal places.
 */
export function scaleGrocery(amount: Amount, groceryServings: number, recipeServings: number): Amount {
  const base = Math.max(recipeServings, 1);
  const raw = Math.ceil((amount.value * groceryServings) / base);
  return { value: Math.max(1, raw), places: amount.places };
}
